module.exports = __webpack_public_path__ + "static/media/shloka_shinde.5d040ae0.png";